import { html } from 'lit';

export const iconFullColor = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M14.9996 7.99954C14.9996 9.31594 14.6531 10.6092 13.9949 11.7492L7.50026 7.99954H14.9996Z"
      fill="#EF5522"
    />
    <path
      d="M14.0135 11.7173C13.3608 12.8605 12.4188 13.8118 11.2819 14.4756L7.50026 7.99954L14.0135 11.7173Z"
      fill="#EC3323"
    />
    <path
      d="M11.2827 14.4766C10.146 15.1404 8.85454 15.4934 7.53815 15.5L7.50068 8.00074L11.2827 14.4766Z"
      fill="#A61D4B"
    />
    <path
      d="M7.54406 15.4985C6.22768 15.5062 4.93246 15.1672 3.7886 14.5157L7.50026 7.99954L7.54406 15.4985Z"
      fill="#7C3692"
    />
    <path
      d="M3.79628 14.5208C2.65167 13.8705 1.69838 12.9305 1.03222 11.7951L7.50068 8.00074L3.79628 14.5208Z"
      fill="#462E90"
    />
    <path
      d="M1.03367 11.7973C0.367063 10.6621 0.0110076 9.3715 0.00128533 8.05513L7.50026 7.99954L1.03367 11.7973Z"
      fill="#3E5CA9"
    />
    <path
      d="M0.00125221 8.06248C-0.0100331 6.74612 0.325382 5.44999 0.973785 4.30434L7.50033 7.99819L0.00125221 8.06248Z"
      fill="#0791CC"
    />
    <path
      d="M0.974796 4.3029C1.6235 3.15743 2.5623 2.20289 3.69683 1.53523L7.50033 7.99819L0.974796 4.3029Z"
      fill="#64AD45"
    />
    <path
      d="M3.70278 1.53253C4.83791 0.865881 6.12851 0.509774 7.44488 0.5L7.50026 7.99954L3.70278 1.53253Z"
      fill="#CDDC39"
    />
    <path
      d="M7.44436 0.502972C8.76073 0.493103 10.0565 0.829912 11.2014 1.47955L7.50058 8.00211L7.44436 0.502972Z"
      fill="#F6EB39"
    />
    <path
      d="M11.1827 1.46792C12.3388 2.11951 13.3013 3.0662 13.9719 4.21135L7.50068 8.00074L11.1827 1.46792Z"
      fill="#F8BA15"
    />
    <path
      d="M13.9719 4.21135C14.6433 5.35787 14.9981 6.66175 14.9999 7.99041L7.50068 8.00074L13.9719 4.21135Z"
      fill="#F8991D"
    />
  </svg>
`;
